
module.exports = {
    ECD,
    activeVolume,
    adjustedChloride,
    adjustedSolidsPercentOil,
    adjustedSolidsPercentWater,
    annularPressureLoss,
    annularPressureLossSection,
    annularVelocity,
    averageSpecificGravityOil,
    averageSpecificGravityWater,
    belowBitVolume,
    bentonitePPB,
    bentonitePercent,
    bitHydraulicHp,
    bitHydraulicHpPerSquareInch,
    bottomUpVolume,
    brineSpecificGravity,
    caCL2mgLWPS,
    calcMagnesium,
    calcPlasticViscosity,
    calcYieldPoint,
    chlorideMilsPerLiter,
    convertUnits,
    criticalVelocity,
    criticalVelocityDrillingFormulas,
    cylinderVolumeBarrels,
    drillSolidsBrineEmulsion,
    drillSolidsPPB,
    drillSolidsPercent,
    duplexPumpFlowRateGallonPerStroke,
    effectiveViscosity,
    excessLimeOil,
    excessLimeWater,
    getSaltTypeCoefficient,
    getSections,
    gravityPPB,
    highGravityPPG,
    highGravityPercent,
    highGravityPercentWater,
    holeCapacity,
    hydrostaticPressure,
    jetImpactForce,
    jetNozzlePressureDrop,
    kValue,
    kValueDrillingFormulaCom,
    lowGravityPPB,
    lowGravityPercent,
    lowGravityPercentWater,
    maximumPipeVelocity,
    mudGradient,
    multiplexPumpFlowRateGallonPerStroke,
    nValue,
    nValueDrillingFormulaCom,
    nozzleArea,
    nozzleVelocity,
    oilRatio,
    openPipeVelocity,
    percentPressureDrop,
    pluggedPipeVelocity,
    pressureLossLaminar,
    pressureLossTurbulent,
    retortContentSolidsPercent,
    reynoldsNumber,
    saltPercentAdjBrineEmulsion,
    saltPercentBrineEmulsion,
    saltPercentByVolume,
    saltPercentWW,
    saltWaterPhase,
    sodiumChloridePresent,
    surfaceToBitVolume,
    surfaceToSurfaceVolume,
    surgePressure,
    surgeSwabPressureLossMethod1,
    swabPressure,
    waterRatio,
    
}

/* tslint:disable */
function getSections(args) {
    if (!args) return undefined;
    if (!Array.isArray(args.intervalSections) || args.intervalSections.length === 0 ) return undefined;

    var drillStringIndex = 0;
    var intervalIndex = 0;
    var returnSectionValue = {};
    var returnSections = [];
    var currentDepth = 0;
    var drillStringDepth = args.drillStringSections[drillStringIndex] ? args.drillStringSections[drillStringIndex].length : 0;
    var intervalDepth = args.intervalSections[intervalIndex].length;
    var drillStringNext = drillStringDepth < intervalDepth;
    var bothNext = drillStringDepth === intervalDepth;
    while (drillStringIndex < args.drillStringSections.length || intervalIndex < args.intervalSections.length) {

        if ( drillStringIndex >= args.drillStringSections.length ) {
            while (intervalIndex < args.intervalSections.length) {
                returnSectionValue = {
                    outerPipeDiameter: 0,
                    innerPipeDiameter: 0,
                    holeDiameter: args.intervalSections[intervalIndex].holeDiameter,
                    length: intervalDepth - currentDepth,
                    hasCasing: args.intervalSections[intervalIndex].hasCasing,
                };
                currentDepth = intervalDepth;
                intervalIndex++;
                intervalDepth += args.intervalSections[intervalIndex] !== undefined ? args.intervalSections[intervalIndex].length : 0;
                returnSections.push(returnSectionValue);
            }
            return returnSections;
        }

        if ( intervalIndex >= args.intervalSections.length) {
            return undefined;
        }

        if (bothNext) {
            returnSectionValue = {
                outerPipeDiameter: args.drillStringSections[drillStringIndex].outerPipeDiameter,
                innerPipeDiameter: args.drillStringSections[drillStringIndex].innerPipeDiameter,
                holeDiameter: args.intervalSections[intervalIndex].holeDiameter,
                length: drillStringDepth - currentDepth,
                hasCasing: args.intervalSections[intervalIndex].hasCasing,
            }
            currentDepth = drillStringDepth;
            drillStringIndex++;
            drillStringDepth += args.drillStringSections[drillStringIndex] !== undefined ? args.drillStringSections[drillStringIndex].length : 0;
            intervalIndex++;
            intervalDepth += args.intervalSections[intervalIndex] !== undefined ? args.intervalSections[intervalIndex].length : 0;
        } else if (drillStringNext) {
            returnSectionValue = {
                outerPipeDiameter: args.drillStringSections[drillStringIndex].outerPipeDiameter,
                innerPipeDiameter: args.drillStringSections[drillStringIndex].innerPipeDiameter,
                holeDiameter: args.intervalSections[intervalIndex].holeDiameter,
                length: drillStringDepth - currentDepth,
                hasCasing: args.intervalSections[intervalIndex].hasCasing,
            }
            currentDepth = drillStringDepth;
            drillStringIndex++;
            drillStringDepth += args.drillStringSections[drillStringIndex] !== undefined ? args.drillStringSections[drillStringIndex].length : 0;
        } else {
            returnSectionValue = {
                outerPipeDiameter: args.drillStringSections[drillStringIndex].outerPipeDiameter,
                innerPipeDiameter: args.drillStringSections[drillStringIndex].innerPipeDiameter,
                holeDiameter: args.intervalSections[intervalIndex].holeDiameter,
                length: intervalDepth - currentDepth,
                hasCasing: args.intervalSections[intervalIndex].hasCasing,
            }
            currentDepth = intervalDepth;
            intervalIndex++;
            intervalDepth += args.intervalSections[intervalIndex] !== undefined ? args.intervalSections[intervalIndex].length : 0;
        }
        returnSections.push(returnSectionValue);
        drillStringNext = drillStringDepth < intervalDepth;
        bothNext = drillStringDepth === intervalDepth;
    }

    return returnSections;
}

function calcPlasticViscosity(args) {
    if (!args) return NaN;
    if (!args.theta600 && typeof(args.theta600) !== 'number') return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;
    return args.theta600 - args.theta300;
}

function calcYieldPoint(args) {
    if (!args) return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;
    if (!args.plasticViscosity && typeof(args.plasticViscosity) !== 'number') return NaN;

    return  args.theta300 - args.plasticViscosity;
}
// Bit Data Calcs

function nozzleArea(args) {  // TFA
    if (!args) return NaN;
    if (!Array.isArray(args.jetSizes)) return NaN;

    var sum = 0;
    for (var i = 0; i < args.jetSizes.length; ++i ) {
        if (args.jetSizes[i] && typeof(args.jetSizes[i]) !== 'number') return NaN;
        sum += args.jetSizes[i] * args.jetSizes[i];
    }
    return sum / 1303.8;
}

// Nozzle Velocity
/*
args:
{
    jetSizes: number[],
    circRate: number,
}
returns:
    number
*/
function nozzleVelocity(args) {
    if (!args) return NaN;
    if (!Array.isArray(args.jetSizes)) return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;

    var sum = 0;
    for (var i = 0; i < args.jetSizes.length; ++i ) {
        if (args.jetSizes[i] && typeof(args.jetSizes[i]) !== 'number') return NaN;
        sum += args.jetSizes[i] * args.jetSizes[i];
    }
    return 417.2 * args.circRate / sum;
}

/*
Jet Impact Force
args:
{
    mudWeight: number,
    nozzleVelocity: number,
    circRate: number,
    bitSize: number,
}
returns:
    number
*/
function jetImpactForce(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.nozzleVelocity && typeof(args.nozzleVelocity) !== 'number') return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;

    return args.mudWeight * args.nozzleVelocity * args.circRate / 1930;
}

/*
Jet Nozzle Pressure Drop
args:
{
    mudWeight: number,
    jetSizes: number[],
    circRate: number,
}
returns:
    number
*/
function jetNozzlePressureDrop(args) {
    if (!args) return NaN;
    if (!Array.isArray(args.jetSizes)) return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;

    var sum = 0;
    for (var i = 0; i < args.jetSizes.length; ++i ) {
        if (args.jetSizes[i] && typeof(args.jetSizes[i]) !== 'number') return NaN;
        sum += args.jetSizes[i] * args.jetSizes[i];
    }
    return 156.5 * args.circRate * args.circRate * args.mudWeight / ( sum * sum )

}

/*
Bit Hydraulic Horsepower
args:
{
    jetNozzlePressureDrop: number,
    circRate: number,
}
returns:
    number
*/
function bitHydraulicHp(args) {
    if (!args) return NaN;
    if (!args.jetNozzlePressureDrop && typeof(args.jetNozzlePressureDrop) !== 'number') return NaN;
    if (!args.circRate && typeof(args.circRate !== 'number')) return NaN;

    return args.circRate * args.jetNozzlePressureDrop / 1714;
}

/*
Bit Hydraulic Horsepower per Square Inch of Bit Area
args:
{
    bitHydraulicHp: number,
    bitSize: number,
}
returns:
    number
*/
function bitHydraulicHpPerSquareInch(args) {
    if (!args) return NaN;
    if (!args.bitHydraulicHp && typeof(args.bitHydraulicHp) !== 'number') return NaN;
    if (!args.bitSize && typeof(args.bitSize !== 'number')) return NaN;

    return args.bitHydraulicHp * 1.27 / ( args.bitSize * args.bitSize );
}

/*
Percent Pressure Drop
args:
{
    jetNozzlePressureDrop: number,
    surfacePressure: number,

}
returns:
    number
*/
function percentPressureDrop(args) {
    if (!args) return NaN;
    if (!args.jetNozzlePressureDrop && typeof(args.jetNozzlePressureDrop) !== 'number') return NaN;
    if (!args.surfacePressure && typeof(args.surfacePressure !== 'number')) return NaN;

    return args.jetNozzlePressureDrop / args.surfacePressure * 100;
}


function nValue(args) {
    if (!args) return NaN;
    if (!args.theta600 && typeof(args.theta600) !== 'number') return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;
    return 3.32 * Math.log(args.theta600 / args.theta300) / Math.log(10);
}

function nValueDrillingFormulaCom(args) {
    if (!args) return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;
    if (!args.theta3 && typeof(args.theta3) !== 'number') return NaN;
    return 0.5 * Math.log(args.theta300 / args.theta3) / Math.log(10);
}

function kValue(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;

    return args.theta300 / Math.pow(511, args.nValue);
}

function kValueDrillingFormulaCom(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;

    return 5.11 * args.theta300 / Math.pow(511, args.nValue);
}

function pluggedPipeVelocity(args) {
    if (!args) return NaN;
    if (!args.tripSpeed && typeof(args.tripSpeed) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;

    return args.tripSpeed * ( 0.45 + (Math.pow(args.pipeDiameter, 2) / (Math.pow(args.holeDiameter, 2) - Math.pow(args.pipeDiameter, 2))));
}

function openPipeVelocity(args) {
    if (!args) return NaN;
    if (!args.tripSpeed && typeof(args.tripSpeed) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.innerPipeDiameter && typeof(args.innerPipeDiameter) !== 'number') return NaN;

    return args.tripSpeed * ( 0.45 + (Math.pow(args.pipeDiameter, 2) - Math.pow(args.innerPipeDiameter, 2)) /
        (Math.pow(args.holeDiameter, 2) - Math.pow(args.pipeDiameter, 2) + Math.pow(args.innerPipeDiameter, 2)));
}

function maximumPipeVelocity(args) {
    if (!args) return NaN;
    if (!args.pipeVelocity && typeof(args.pipeVelocity) !== 'number') return NaN;

    return 1.5 * args.pipeVelocity;

}

function annularPressureLoss(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;
    if (!args.pipeSections && !Array.isArray(args.pipeSections)) return NaN;
    if (!args.annularVelocityFunction && typeof(args.annularVelocityFunction) !== 'function') return NaN;
    if (!args.annularPressureLossSectionFunction && typeof(args.annularPressureLossSectionFunction) !== 'function') return NaN;

    var totalPressureLoss = 0;
    var tempAnnularVelocity = 0;
    for (var i = 0; i < args.pipeSections.length; ++i) {
        tempAnnularVelocity = args.annularVelocityFunction({
            circRate: args.circRate,
            holeDiameter: args.pipeSections[i].holeDiameter,
            pipeDiameter: args.pipeSections[i].outerPipeDiameter
        });
        totalPressureLoss += args.annularPressureLossSectionFunction({
            annularVelocity: tempAnnularVelocity,
            holeDiameter: args.pipeSections[i].holeDiameter,
            mudWeight: args.mudWeight,
            pipeDiameter: args.pipeSections[i].outerPipeDiameter,
            pipeLength: args.pipeSections[i].length,
        });
    }
    return totalPressureLoss;
}
function annularPressureLossSection(args) {
    if (!args) return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.pipeLength && typeof(args.pipeLength) !== 'number') return NaN;
    if (!args.annularVelocity && typeof(args.annularVelocity) !== 'number') return NaN;

    return 1.4327e-7 * args.mudWeight * args.pipeLength * Math.pow(args.annularVelocity, 2) / ( args.holeDiameter - args.pipeDiameter);
}


function surgeSwabPressureLossMethod1(args) {
    if (!args) return NaN;
    if (!args.isPipeOpen && typeof(args.isPipeOpen) !== 'boolean') return NaN;
    if (!args.openPipeVelocityFunction && typeof(args.openPipeVelocityFunction) !== 'function') return NaN;
    if (!args.pluggedPipeVelocityFunction && typeof(args.pluggedPipeVelocityFunction) !== 'function') return NaN;
    if (!args.maximumPipeVelocityFunction && typeof(args.maximumPipeVelocityFunction) !== 'function') return NaN;
    if (!args.pressureLossFunction && typeof(args.pressureLossFunction) !== 'function') return NaN;
    if (!args.kValueFunction && typeof(args.kValueFunction) !== 'function') return NaN;
    if (!args.nValueFunction && typeof(args.nValueFunction) !== 'function') return NaN;
    if (!args.theta600 && typeof(args.theta600) !== 'number') return NaN;
    if (!args.theta300 && typeof(args.theta300) !== 'number') return NaN;
    if (!args.tripSpeed && typeof(args.tripSpeed) !== 'number') return NaN;
    if (!args.pipeSections && typeof(args.pipeSections) !== 'object') return NaN;


    var myNValue = args.nValueFunction({theta300: args.theta300, theta600: args.theta600});
    var myKValue = args.kValueFunction({nValue: myNValue, theta300: args.theta300});

    if(!Array.isArray(args.pipeSections)) return NaN;
    var pressureDropSum = 0;
    for ( var i = 0; i < args.pipeSections.length; i++ ) {
        if (args.pipeSections[i].outerPipeDiameter === 0) {
            break;
        }
        var myVelocity;
        if (args.isPipeOpen) {
            myVelocity = args.openPipeVelocityFunction(
                {
                    tripSpeed: args.tripSpeed,
                    pipeDiameter: args.pipeSections[i].outerPipeDiameter,
                    innerPipeDiameter: args.pipeSections[i].innerPipeDiameter,
                    holeDiameter: args.pipeSections[i].holeDiameter,
                }
                );
        } else {
            myVelocity = args.pluggedPipeVelocityFunction(
                {
                    tripSpeed: args.tripSpeed,
                    pipeDiameter: args.pipeSections[i].outerPipeDiameter,
                    holeDiameter: args.pipeSections[i].holeDiameter
                }
            );
        }
        myMaxVelocity = args.maximumPipeVelocityFunction({pipeVelocity: myVelocity})
        var currPressureLoss = args.pressureLossFunction(
            {
                nValue: myNValue,
                kValue: myKValue,
                holeDiameter: args.pipeSections[i].holeDiameter,
                pipeDiameter: args.pipeSections[i].outerPipeDiameter,
                velocity: myMaxVelocity,
                length: args.pipeSections[i].length,
            }
        );
        pressureDropSum += currPressureLoss;
    }

    return pressureDropSum;
}

function annularVelocity(args) {
    if (!args) return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;

    return 24.5 * args.circRate / ( args.holeDiameter * args.holeDiameter - args.pipeDiameter * args.pipeDiameter );

}

function criticalVelocity(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.kValue && typeof(args.kValue) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    var constantVal = 3.878e4;
    var leftQuantity = Math.pow( constantVal * args.kValue / args.mudWeight, 1 / ( 2 - args.nValue ) );
    var rightQuantity = Math.pow( 2.4 * ( 2 * args.nValue + 1 ) / ( ( args.holeDiameter - args.pipeDiameter )
         * 3 * args.nValue ), args.nValue / ( 2 - args.nValue ) );
    return leftQuantity * rightQuantity;
}


function criticalVelocityDrillingFormulas(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.kValue && typeof(args.kValue) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;

    var numerator = ( 3470 - 1370 * args.nValue ) * 100 * args.kValue * Math.pow(( 2 * args.nValue + 1 ) / ( 3 * args.nValue ), args.nValue);
    var denominator = 928 * args.mudWeight * ( args.holeDiameter - args.pipeDiameter ) * Math.pow(144 / ( args.holeDiameter - args.pipeDiameter ), 1 - args.nValue );
    // Formula in fps so convert to fpm
    return 60 * Math.pow(numerator / denominator, 1 / ( 2 - args.nValue ) );
}

function pressureLossLaminar(args) {
    if (!args) return NaN;
    if (!args.velocity && typeof(args.velocity) !== 'number') return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.kValue && typeof(args.kValue) !== 'number') return NaN;
    if (!args.length && typeof(args.length) !== 'number') return NaN;

    var tempVal = 2.4 * args.velocity * ( 2 * args.nValue + 1 ) / ( args.holeDiameter - args.pipeDiameter ) / ( 3 * args.nValue );
    return Math.pow( tempVal, args.nValue ) * args.kValue * args.length / ( 300 * ( args.holeDiameter - args.pipeDiameter ) );

}

function pressureLossTurbulent(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.circRate && typeof(args.circRate) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.length && typeof(args.length) !== 'number') return NaN;
    if (!args.plasticViscosity && typeof(args.plasticViscosity) !== 'number') return NaN;

    var numerator = 7.7 * Math.pow(10, -5) * Math.pow(args.mudWeight, 0.8)
        * Math.pow(args.circRate, 1.8) * Math.pow(args.plasticViscosity, 0.2) * args.length;

    var denominator = Math.pow(args.holeDiameter - args.pipeDiameter, 3) * Math.pow(args.holeDiameter + args.pipeDiameter, 1.8);
    return numerator / denominator;

}

function swabPressure(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.pressureLoss && typeof(args.pressureLoss) !== 'number') return NaN;
    if (!args.depthTVD && typeof(args.depthTVD) !== 'number') return NaN;


    return args.mudWeight - args.pressureLoss / ( 0.052 * args.depthTVD );
}

function surgePressure(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.pressureLoss && typeof(args.pressureLoss) !== 'number') return NaN;
    if (!args.depthTVD && typeof(args.depthTVD) !== 'number') return NaN;

    return args.mudWeight + args.pressureLoss / ( 0.052 * args.depthTVD );
}

function ECD(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.depthTVD && typeof(args.depthTVD) !== 'number') return NaN;
    if (!args.annularPressureLoss && typeof(args.annularPressureLoss) !== 'number') return NaN;

    return args.annularPressureLoss / ( 0.052 * args.depthTVD ) + args.mudWeight;
}

function hydrostaticPressure(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;
    if (!args.depthTVD && typeof(args.depthTVD) !== 'number') return NaN;
    return 0.052 * args.mudWeight * args.depthTVD;
}

function duplexPumpFlowRateGallonPerStroke(args) {
    if (!args) return NaN;
    if (!args.linerDiameter && typeof(args.linerDiameter) !== 'number') return NaN;
    if (!args.rodDiameter && typeof(args.rodDiameter) !== 'number') return NaN;
    if (!args.strokeLength && typeof(args.strokeLength) !== 'number') return NaN;
    if (!args.volumeEfficiency && typeof(args.volumeEfficiency) != 'number') return NaN;

    return 0.0068 * ( 2 * args.linerDiameter * args.linerDiameter - args.rodDiameter * args.rodDiameter )
         * args.strokeLength * args.volumeEfficiency;
}


function multiplexPumpFlowRateGallonPerStroke(args) {
    if (!args) return NaN;
    if (!args.linerDiameter && typeof(args.linerDiameter) !== 'number') return NaN;
    if (!args.strokeLength && typeof(args.strokeLength) !== 'number') return NaN;
    if (!args.volumeEfficiency && typeof(args.volumeEfficiency) != 'number') return NaN;
    if (!args.linerQty && typeof(args.linerQty) !== 'number') return NaN;

    return args.volumeEfficiency * Math.PI * args.strokeLength
        * Math.pow(( args.linerDiameter / 2 ), 2) * args.linerQty / 231;
}

function surfaceToBitVolume(args) {
    if (!args) return NaN;
    if (!args.cylinderVolumeFunction && typeof(args.cylinderVolumeFunction) !== 'function') return NaN;
    if (!args.pipeSections && typeof(args.pipeSections) !== 'object') return NaN;

    if(!Array.isArray(args.pipeSections)) return NaN;
    var volumeSum = 0;
    for ( var i = 0; i < args.pipeSections.length; i++ ) {
        volumeSum +=  args.cylinderVolumeFunction({
            outerDiameter: args.pipeSections[i].innerPipeDiameter,
            innerDiameter: 0,
            length: args.pipeSections[i].length
        });
    }
    return volumeSum;
}

function cylinderVolumeBarrels(args) {
    if (!args) return NaN;
    if (!args.outerDiameter && typeof(args.outerDiameter) !== 'number') return NaN;
    if (!args.length && typeof(args.length) !== 'number') return NaN;
    if (args.innerDiameter === undefined || typeof(args.innerDiameter) !== 'number') return NaN;

    return args.length * ( args.outerDiameter * args.outerDiameter -
        args.innerDiameter * args.innerDiameter ) / 1029.41;
}

function bottomUpVolume(args) {
    if (!args) return NaN;
    if (!args.cylinderVolumeFunction && typeof(args.cylinderVolumeFunction) !== 'function') return NaN;
    if (!args.pipeSections && typeof(args.pipeSections) !== 'object') return NaN;
    if(!Array.isArray(args.pipeSections)) return NaN;
    var volumeSum = 0;
    for ( var i = 0; i < args.pipeSections.length; i++ ) {
        if (args.pipeSections[i].outerPipeDiameter === 0) {
            break;
        }
        volumeSum +=  args.cylinderVolumeFunction({
            innerDiameter: args.pipeSections[i].outerPipeDiameter,
            outerDiameter: args.pipeSections[i].holeDiameter,
            length: args.pipeSections[i].length,
        });
    }
    return volumeSum;
}


function surfaceToSurfaceVolume(args) {
    if (!args) return NaN;
    if (!args.surfaceToBitVolume && typeof(args.surfaceToBitVolume) !== 'number') return NaN;
    if (!args.bottomUpVolume && typeof(args.bottomUpVolume) !== 'number') return NaN;

    return args.surfaceToBitVolume + args.bottomUpVolume;

}

function belowBitVolume(args) {
    if (!args) return NaN;
    if (!args.cylinderVolumeFunction && typeof(args.cylinderVolumeFunction) !== 'function') return NaN;
    if (!args.pipeSections && typeof(args.pipeSections) !== 'object') return NaN;
    if(!Array.isArray(args.pipeSections)) return NaN;
    var volumeSum = 0;
    for ( var i = 0; i < args.pipeSections.length; i++ ) {
        if (args.pipeSections[i].outerPipeDiameter !== 0) {
            continue;
        }
        volumeSum +=  args.cylinderVolumeFunction({
            innerDiameter: 0,
            outerDiameter: args.pipeSections[i].holeDiameter,
            length: args.pipeSections[i].length,
        });
    }
    return volumeSum;
}

function activeVolume(args) {
    if (!args) return NaN;
    if (!args.surfaceToSurfaceVolume && typeof(args.surfaceToSurfaceVolume) !== 'number') return NaN;
    if (!args.pitVolume && typeof(args.pitVolume) !== 'number') return NaN;

    return args.surfaceToSurfaceVolume + args.pitVolume;

}

function holeCapacity(args) {
    if (!args) return NaN;
    if (!args.surfaceToSurfaceVolume && typeof(args.surfaceToSurfaceVolume) !== 'number') return NaN;
    if (!args.belowBitVolume && typeof(args.belowBitVolume) !== 'number') return NaN;

    return args.surfaceToSurfaceVolume + args.belowBitVolume;

}

function convertUnits(args) {
    if (!args) return NaN;
    if (!args.conversionFactor && typeof(args.conversionFactor) !== 'number') return NaN;
    if (!args.valueToConvert && typeof(args.valueToConvert) !== 'number') return NaN;

    return args.conversionFactor * args.valueToConvert;
}

function mudGradient(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;

    return args.mudWeight * 0.052;
}

// from http://www.drillingformulas.com/effective-viscosity-calculation/
function effectiveViscosity(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.kValue && typeof(args.kValue) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.annularVelocity && typeof(args.annularVelocity) !== 'number') return NaN;

    return 100 * args.kValue * Math.pow( ( 144 * args.annularVelocity / 60 / ( args.holeDiameter - args.pipeDiameter )), args.nValue - 1 );
}

// from http://www.drillingformulas.com/reynold-number-for-drilling-hydraulics/
function reynoldsNumber(args) {
    if (!args) return NaN;
    if (!args.nValue && typeof(args.nValue) !== 'number') return NaN;
    if (!args.effectiveViscosity && typeof(args.effectiveViscosity) !== 'number') return NaN;
    if (!args.holeDiameter && typeof(args.holeDiameter) !== 'number') return NaN;
    if (!args.pipeDiameter && typeof(args.pipeDiameter) !== 'number') return NaN;
    if (!args.annularVelocity && typeof(args.annularVelocity) !== 'number') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN;

    var numerator = 928 * args.annularVelocity / 60 * ( args.holeDiameter - args.pipeDiameter ) * args.mudWeight;
    var denominator = args.effectiveViscosity * Math.pow( ( 2 * args.nValue + 1 ) / ( 3 * args.nValue ), args.nValue );
    return numerator / denominator;
}

// Solids Calculations


function excessLimeOil(args) {
    if (!args) return NaN;
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN;

    return 1.295 * args.alkalinity;
}

function excessLimeWater(args) {
    if (!args) return NaN;
    if (!args.mudAlkalinity && typeof(args.mudAlkalinity) !== 'number') return NaN;
    if (!args.filtrateAlkalinity && typeof(args.filtrateAlkalinity) !== 'number') return NaN;
    if (!args.fractionWater && typeof(args.fractionWater) !== 'number') return NaN;

    return 0.26 * ( args.mudAlkalinity - ( args.filtrateAlkalinity * args.fractionWater ) );
}

function calcMagnesium(args) {
    if (!args) return NaN;
    if (!args.totalHardness && typeof(args.totalHardness) !== 'number') return NaN;
    if (!args.calcium && typeof(args.calcium) !== 'number') return NaN;

    return ( args.totalHardness - args.calcium ) / 400 * 243;

}
// Water Based Mud

function adjustedChloride(args) {
    if (!args) return NaN;
    if (!args.chlorideMilsPerLiter && typeof(args.chlorideMilsPerLiter) !== 'number') return NaN;
    if (!args.saltPercentByVolume && typeof(args.saltPercentByVolume) !== 'number') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN;

    return args.chlorideMilsPerLiter * (args.saltPercentByVolume + args.waterVolumePercent) / 100;
}


function getSaltTypeCoefficient(args) {
    if (!args) return NaN;
    if (!args.saltType && typeof(args.saltType) !== 'string') return NaN;

    if (args.saltType === 'NACL / WBM / Water') {
        return 1.65;
    } else if (args.saltType === 'CaCL2') {
        return 1.565;
    } else if (args.saltType === 'KCL') {
        return 2.103;
    } else return NaN;
}
// Salt % Volume - output

function saltPPB(args) {
    if (!args) return NaN;
    if (!args.adjustedChloride && typeof(args.adjustedChloride) !== 'number') return NaN;
    if (!args.getSaltTypeCoefficientFunction && typeof(args.getSaltTypeCoefficientFunction) !== 'function') return NaN;
    if (!args.saltType && typeof(args.saltType) !== 'string') return NaN;

    var saltTypeCoefficient = args.getSaltTypeCoefficientFunction({saltType: args.saltType});
    return saltTypeCoefficient * args.adjustedChloride * 0.00035051;
}

// =((1.65*(C15/10000))/((1.65*(C15/10000))+C7))*100
function saltPercentWW(args) {
    if (!args) return NaN;
    if (!args.adjustedChloride && typeof(args.adjustedChloride) !== 'number') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN;
    if (!args.getSaltTypeCoefficientFunction && typeof(args.getSaltTypeCoefficientFunction) !== 'function') return NaN;
    if (!args.saltType && typeof(args.saltType) !== 'string') return NaN;


    var saltTypeCoefficient = args.getSaltTypeCoefficientFunction({saltType: args.saltType});
    return saltTypeCoefficient * args.adjustedChloride / 10000 / (saltTypeCoefficient * args.adjustedChloride / 10000 + args.waterVolumePercent) * 100;
}


// NACL =( ( 0.001732734 + ( 0.0000004869 * C8 ) + ( 8.06345E-13 * ( C8^2 ) ) - ( 1.24114E-18 * ( C8^3 ) ) ) * 100 ) * ( C7 / 100 )
// CACL2 =(((-0.0002925696)+(0.000000304*E8)+(5.22217E-13*(E8^2))-(3.123211E-19*(E8^3)))*100)*(E7/100)
// KCL =((0.00028635+(0.0000008854*G8)+(3.87791E-15*(G8^2))+(1.27435E-20*(G8^3)))*100)*(G7/100)
// C8 = chloride C7 = waterVolume
function saltPercentByVolume(args) {
    if (!args) return NaN;
    if (!args.chlorideMilsPerLiter && typeof(args.chlorideMilsPerLiter) !== 'number') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN;
    if (!args.saltType && typeof(args.saltType) !== 'string') return NaN;

    if (args.saltType === 'NACL / WBM / Water') {
        return ((0.001732734+(0.0000004869*args.chlorideMilsPerLiter)+ (8.06345e-13 * Math.pow(args.chlorideMilsPerLiter, 2))
        - (1.24114e-18 * Math.pow(args.chlorideMilsPerLiter, 3)))*100) * args.waterVolumePercent / 100;
    } else if (args.saltType === 'CaCL2') {
        return ((-0.0002925696+(0.000000304*args.chlorideMilsPerLiter)+ (5.22217e-13 * Math.pow(args.chlorideMilsPerLiter, 2))
        - (3.123211e-19 * Math.pow(args.chlorideMilsPerLiter, 3)))*100) * args.waterVolumePercent / 100;
    } else if (args.saltType === 'KCL') {
        return ((0.00028635+(0.0000008854*args.chlorideMilsPerLiter)+ (3.87791e-15 * Math.pow(args.chlorideMilsPerLiter, 2))
        + (1.27435e-20 * Math.pow(args.chlorideMilsPerLiter, 3)))*100) * args.waterVolumePercent / 100;
    } else return NaN;

}

function saltPercentBrineEmulsion(args) {
    if (!args) return NaN;
    if (args.chlorideMilsPerLiter === undefined || typeof(args.chlorideMilsPerLiter) !== 'number') return NaN;

    return args.chlorideMilsPerLiter * 0.00006;
}

function saltPercentAdjBrineEmulsion(args) {
    if (!args) return NaN;
    if (args.chlorideMilsPerLiter === undefined || typeof(args.chlorideMilsPerLiter) !== 'number') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN;

    return args.chlorideMilsPerLiter * 0.00006 * args.waterVolumePercent * 0.01;
}

function drillSolidsBrineEmulsion(args) {
    if (!args) return NaN;
    if (args.saltPercentAdjBrineEmulsion === undefined || typeof(args.saltPercentAdjBrineEmulsion) !== 'number') return NaN;
    if (args.solidVolumePercent === undefined || typeof(args.solidVolumePercent) !== 'number') return NaN;

    return args.solidVolumePercent - args.saltPercentAdjBrineEmulsion;
}
// NACL =1+(0.00710426*C18)+(0.0000117068*(C18^2))+(0.0000003798*(C18^3))
// CACL2 =1+(0.00811724*E18)+(0.0000407148*(E18^2))+(0.0000001326*(E18^3))
// KCL =1.000298+(0.005752998*G18)+(0.00002544016*(G18^2))+(0.0000005213617*(G18^3))
function brineSpecificGravity(args) {
    if (!args) return NaN;
    if (!args.saltPercentWW && typeof(args.saltPercentWW) !== 'number') return NaN;
    if (!args.saltType && typeof(args.saltType) !== 'string') return NaN;

    if (args.saltType === 'NACL / WBM / Water') {
        return 1 + (0.00710426 * args.saltPercentWW) + (0.0000117068*(Math.pow(args.saltPercentWW, 2)))+(0.0000003798*(Math.pow(args.saltPercentWW, 3)));
    } else if (args.saltType === 'CaCL2') {
        return 1 + (0.00811724 * args.saltPercentWW) + (0.0000407148*(Math.pow(args.saltPercentWW, 2)))+(0.0000001326*(Math.pow(args.saltPercentWW, 3)));
    } else if (args.saltType === 'KCL') {
        return 1.000298 + (0.005752998 * args.saltPercentWW) + (0.00002544016*(Math.pow(args.saltPercentWW, 2)))+(0.0000005213617*(Math.pow(args.saltPercentWW, 3)));
    } else return NaN;
}

// =100-C6-C7-C17
function adjustedSolidsPercentWater(args) {
    if (!args) return NaN;
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN;
    if (!args.saltPercentByVolume && typeof(args.saltPercentByVolume) !== 'number') return NaN;

    return 100 - args.oilVolumePercent - args.waterVolumePercent - args.saltPercentByVolume;

}


//  ASG - output
// Low Gravity % and Lb/bbl - output  =((C19+((C21*(C9-C19))/100)-(C4/8.345)-((C6*(C19-C10))/100))/(C9-C11))*100
function lowGravityPercentWater(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // C4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // C6
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // C9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // C10
    if (!args.lowGravitySolidSpecificGravity && typeof(args.lowGravitySolidSpecificGravity) !== 'number') return NaN; // C11
    if (!args.brineSpecificGravity && typeof(args.brineSpecificGravity) !== 'number') return NaN; // C19
    if (!args.adjSolidsPercent && typeof(args.adjSolidsPercent) !== 'number') return NaN; // C21

    return ((args.brineSpecificGravity + (( args.adjSolidsPercent * ( args.wtMaterialSpecificGravity - args.brineSpecificGravity )) / 100 )
        - ( args.mudWeight / 8.345 ) - (( args.oilVolumePercent * (args.brineSpecificGravity - args.oilSpecificGravity)) /100 )) 
        / (args.wtMaterialSpecificGravity - args.lowGravitySolidSpecificGravity )) * 100;

}

// High Gravity % and Lb/bbl - output
// =C21-C22
function highGravityPercentWater(args) {
    if (!args) return NaN;
    if (!args.adjSolidsPercent && typeof(args.adjSolidsPercent) !== 'number') return NaN; // C21
    if (!args.lowGravityPercent && typeof(args.lowGravityPercent) !== 'number') return NaN; // C22

    return args.adjSolidsPercent - args.lowGravityPercent;
}

// =(C22*C11*8.345*42)/100
// =(C24*8.345*42*C9)/100
function gravityPPB(args) {
    if (!args) return NaN;
    if (!args.gravityPercent && typeof(args.gravityPercent) !== 'number') return NaN; // C22 or C24
    if (!args.gravitySolidSpecificGravity && typeof(args.gravitySolidSpecificGravity) !== 'number') return NaN; // C11 or C9

    return (args.gravityPercent * args.gravitySolidSpecificGravity * 8.345 * 42 ) / 100;
}

// Bentonite % and Lb/bbl - output
// =((C23*((C12*(60/C23))-C13))/(60-C13))
function bentonitePPB(args) {
    if (!args) return NaN;
    if (!args.lowGravityPPB && typeof(args.lowGravityPPB) !== 'number') return NaN; // C23
    if (!args.methyleneBlueTest  && typeof(args.methyleneBlueTest) !== 'number') return NaN; // C12
    if (!args.cationExchangeCapacity  && typeof(args.cationExchangeCapacity) !== 'number') return NaN; // C13

    return ((args.lowGravityPPB * (( args.methyleneBlueTest * ( 60 / args.lowGravityPPB )) - args.cationExchangeCapacity )) 
        / (60 - args.cationExchangeCapacity));
}

// =((C27*100)/(8.345*42*C11))
function bentonitePercent(args) {
    if (!args) return NaN;
    if (!args.lowGravitySolidSpecificGravity && typeof(args.lowGravitySolidSpecificGravity) !== 'number') return NaN; // C11
    if (!args.bentonitePPB  && typeof(args.bentonitePPB) !== 'number') return NaN; // C27

    return (( args.bentonitePPB * 100 ) / (8.345 * 42 * args.lowGravitySolidSpecificGravity));

}
// Drill Solids % and Lb/bbl - output

//=C22-C26
function drillSolidsPercent(args) {
    if (!args) return NaN;
    if (!args.lowGravityPercent && typeof(args.lowGravityPercent) !== 'number') return NaN;
    if (!args.bentonitePercent && typeof(args.bentonitePercent) !== 'number') return NaN;

    return args.lowGravityPercent - args.bentonitePercent;
}

// =C23-C27
function drillSolidsPPB(args) {
    if (!args) return NaN;
    if (!args.lowGravityPPB && typeof(args.lowGravityPPB) !== 'number') return NaN;
    if (!args.bentonitePPB && typeof(args.bentonitePPB) !== 'number') return NaN;

    return args.lowGravityPPB - args.bentonitePPB;
}

// =((100*(C4/8.345))-((C17+C7)*C19)-(C6*C10))/C21
function averageSpecificGravityWater(args) {
    if (!args) return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // C4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // C6
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // C7
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // C10
    if (!args.saltPercentByVolume && typeof(args.saltPercentByVolume) !== 'number') return NaN; // C17
    if (!args.brineSpecificGravity && typeof(args.brineSpecificGravity) !== 'number') return NaN; // C19
    if (!args.adjSolidsPercent && typeof(args.adjSolidsPercent) !== 'number') return NaN; // C21

    return ( ( 100 * ( args.mudWeight / 8.345 ) ) - ( ( args.saltPercentByVolume + args.waterVolumePercent ) 
        * args.brineSpecificGravity) - ( args.oilVolumePercent * args.oilSpecificGravity ) ) / args.adjSolidsPercent;
}

// OBM calcs

function sodiumChloridePresent(args) {
    if (!args) return undefined;
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return undefined;
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return undefined;

    return args.chlorideCM3 * 10000 - ( args.versenateCM3 * 4000 * 1.769 ) > 0;
}


// ASG
// =IF($D$19<0,$K$10/8.345,"    N/A")
function averageSpecificGravityOil(args){
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // B10
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // B11
    if (!args.drillSolidsSpecificGravity && typeof(args.drillSolidsSpecificGravity) !== 'number') return NaN; // B12

    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        var L9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((L8/100)*L5);
        var D30 = 100 - args.oilVolumePercent-L8;
        var L10 = L9/(D30/100);
        return L10 / 8.345;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        var K5 = B25 * 8.345;
        var K9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((K8/100)*K5);
        var B30 = 100-args.oilVolumePercent - K8;
        var K10 = K9/(B30/100);
        return K10 / 8.345

    }


}

function caCL2mgLWPS(args) {
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    
    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L6 = D24 * 10000;
        var D28 = L6 * D25;
        return D28;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K6 = B24 * 10000;
        var B28 = K6 * B25;
        return B28;
    }

}
function saltWaterPhase(args) {
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9

    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        return 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
    }
    else {
        var B22 = D17 * 1.57;
        return B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
    }
}



// low gravity % and ppb
// low gravity % w/o nacl  =IF($D$19<0,$B$30*$K$12,"    N/A")
// K12 = =IF($D$19<0,1-$K$11,"    N/A")
// K11 = =IF($D$19<0,($K$10-($B$12*8.345))/(($B$11*8.345)-($B$12*8.345)),"    N/A")
// K10 = =IF($D$19<0,$K$9/($B$30/100),"    N/A")
// B30 = =IF($D$19<0,100-$B$5-$K$8,"    N/A")
// K9 = =IF($D$19<0,$B$4-(($B$5/100)*($B$10*8.345))-(($K$8/100)*$K$5),"    N/A")
// K8 = =IF($D$19<0,100*$B$6/($B$25*(100-$B$24)),"    N/A")
// K5 = =IF($D$19<0,$B$25*8.345,"    N/A")
// B25 = =IF($D$19<0,1+(0.008117*$B$24)+(0.000040715*($B$24^2))+(0.0000001326*($B$24^3)),"    N/A")
// B24 =IF($D$19<0,$B$22*100/($B$22+(($B$6/100)*1000000)),"    N/A")
// B22 = =IF($D$19<0,$D$17*1.57,"    N/A")
// D17 = =$B$8*10000
// b5 = Oil content %
// b6 = WaterContent%
// B8 = ChlorideCM3
// B10 = oilSpecificGravity
// B11 = wtMaterialSpecificGravity
// B12 = drillSolidsSpecificGravity

// with nacl
// =IF($D$19>0,$D$30*$L$12,"    N/A")
// L12 = =IF($D$19>0,1-$L$11,"    N/A")
// L11 = =IF($D$19>0,($L$10-($B$12*8.345))/(($B$11*8.345)-($B$12*8.345)),"    N/A")
// L10 = =IF($D$19>0,$L$9/($D$30/100),"    N/A")
// D30 = adjusted solids =IF($D$19>0,100-$B$5-$L$8,"    N/A")
// L9 = =IF($D$19>0,$B$4-(($B$5/100)*($B$10*8.345))-(($L$8/100)*$L$5),"    N/A")
// L8 = =IF($D$19>0,100*$B$6/($D$25*(100-$D$24-$G$24)),"    N/A")
// L5 = =IF($D$19>0,$D$25*8.345,"    N/A")
// D25 = =IF($D$19>0,0.99707+(0.0065*$G$24)+(0.0000439*($G$24^2))+(0.00792*$D$24)+(0.0000496*($D$24^2))+(0.00008334*$D$24*$G$24),"    N/A")
// G24 = =IF($K$1>$I$24,$I$24,IF($K$1<$I$24,$K$1,"    N/A"))
// K1 = =IF($D$19>0,100*$G$22/($G$22+$D$22+(($B$6/100)*1000000)),0)
// I24 = =IF($D$19>0,26.432-(1.0472*$D$24)+(0.00798191*($D$24^2))+(0.000052238*($D$24^3)),"   NONE")
// D24 = =IF($D$19>0,100*$D$22/($D$22+$G$22+(($B$6/100)*1000000)),"    N/A")
// G22 = =IF($D$19>0,$J$2,"    N/A")
// J2 =IF($B$7>0.75,(1.648*$D$17)-(3004*((4*$B$9)-1.5)),(1.648*$D$17)-(3004*((4*$B$9)-(1.997*$B$7))))
// D22 = =IF($D$19>0,$D$18*2.769,"    N/A")
// D18 = =($B$9*4000)


function lowGravityPercent(args){
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // B10
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // B11
    if (!args.drillSolidsSpecificGravity && typeof(args.drillSolidsSpecificGravity) !== 'number') return NaN; // B12

    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        var L9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((L8/100)*L5);
        var D30 = 100 - args.oilVolumePercent-L8;
        var L10 = L9/(D30/100);
        var L11 = (L10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        var L12 = (1-L11);
        return D30 * L12;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        var K5 = B25 * 8.345;
        var K9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((K8/100)*K5);
        var B30 = 100-args.oilVolumePercent - K8;
        var K10 = K9/(B30/100);
        var K11 = (K10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        var K12 = 1-K11;
        return B30 * K12;

    }



}

// low gravity ppb
// =IF($D$19<0,($B$12*8.345)*$K$12*($B$30/100)*42,"    N/A")
function lowGravityPPB(args) {
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // B10
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // B11
    if (!args.drillSolidsSpecificGravity && typeof(args.drillSolidsSpecificGravity) !== 'number') return NaN; // B12
    
    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        var L9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((L8/100)*L5);
        var D30 = 100 - args.oilVolumePercent-L8;
        var L10 = L9/(D30/100);
        var L11 = (L10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        var L12 = (1-L11);
        // =IF($D$19>0,($B$12*8.345)*$L$12*($D$30/100)*42,"    N/A")
        return args.drillSolidsSpecificGravity*8.345*L12*(D30/100)*42;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        var K5 = B25 * 8.345;
        var K9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((K8/100)*K5);
        var B30 = 100-args.oilVolumePercent - K8;
        var K10 = K9/(B30/100);
        var K11 = (K10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        var K12 = 1-K11;
        // =IF($D$19<0,($B$12*8.345)*$K$12*($B$30/100)*42,"    N/A")
        return args.drillSolidsSpecificGravity*8.345*K12*(B30/100)*42;
    }
}

// high gravity % and ppb
function highGravityPercent(args){
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // B10
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // B11
    if (!args.drillSolidsSpecificGravity && typeof(args.drillSolidsSpecificGravity) !== 'number') return NaN; // B12

    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        var L9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((L8/100)*L5);
        var D30 = 100 - args.oilVolumePercent-L8;
        var L10 = L9/(D30/100);
        var L11 = (L10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        return D30 * L11;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        var K5 = B25 * 8.345;
        var K9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((K8/100)*K5);
        var B30 = 100-args.oilVolumePercent - K8;
        var K10 = K9/(B30/100);
        var K11 = (K10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        return B30 * K11;

    }


}

function highGravityPPG(args){
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (!args.oilSpecificGravity && typeof(args.oilSpecificGravity) !== 'number') return NaN; // B10
    if (!args.wtMaterialSpecificGravity && typeof(args.wtMaterialSpecificGravity) !== 'number') return NaN; // B11
    if (!args.drillSolidsSpecificGravity && typeof(args.drillSolidsSpecificGravity) !== 'number') return NaN; // B12
    
    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        var L9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((L8/100)*L5);
        var D30 = 100 - args.oilVolumePercent-L8;
        var L10 = L9/(D30/100);
        var L11 = (L10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        var L12 = (1-L11);
        // =IF($D$19>0,$B$11*8.345*$L$11*($D$30/100)*42,"    N/A")
        return args.wtMaterialSpecificGravity*8.345*L11*(D30/100)*42;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        var K5 = B25 * 8.345;
        var K9 = args.mudWeight-((args.oilVolumePercent/100)*(args.oilSpecificGravity*8.345))-((K8/100)*K5);
        var B30 = 100-args.oilVolumePercent - K8;
        var K10 = K9/(B30/100);
        var K11 = (K10-(args.drillSolidsSpecificGravity*8.345))/((args.wtMaterialSpecificGravity*8.345)-(args.drillSolidsSpecificGravity*8.345));
        // =IF($D$19<0,$B$11*8.345*$K$11*($B$30/100)*42,"    N/A")
        return args.wtMaterialSpecificGravity*8.345*K11*(B30/100)*42;
    }
}

// retortContentSolidsPercent
function retortContentSolidsPercent(args) {
    if (!args) return NaN;
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6

    return 100-args.oilVolumePercent-args.waterVolumePercent;
}
// oil and water ratio owr
function oilRatio(args) {
    if (!args) return NaN;
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    // 100*$B$5/($B$5+$B$6)
    return 100* args.oilVolumePercent/ ( args.oilVolumePercent + args.waterVolumePercent);
}
function waterRatio(args) {
    if (!args) return NaN;
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6

    return 100* args.waterVolumePercent/ ( args.oilVolumePercent + args.waterVolumePercent);
}
// Solids Adj for Salt percent
// =IF($D$19<0,100-$B$5-$K$8,"    N/A")
// =IF($D$19>0,100-$B$5-$L$8,"    N/A")
function adjustedSolidsPercentOil(args) {
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.mudWeight && typeof(args.mudWeight) !== 'number') return NaN; // B4
    if (args.oilVolumePercent === undefined || typeof(args.oilVolumePercent) !== 'number') return NaN; // B5
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    
    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L5 = D25 * 8.345;
        var L8 = 100 * args.waterVolumePercent/(D25*(100-D24-G24));
        return 100 - args.oilVolumePercent - L8;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K8 = 100 * args.waterVolumePercent / ( B25 * ( 100-B24 ) );
        return 100 - args.oilVolumePercent - K8;
    }
}

function chlorideMilsPerLiter(args) {
    if (!args) return NaN;
    if (!args.sodiumChloridePresentFunction && typeof(args.sodiumChloridePresentFunction) !== 'function') return NaN;
    if (!args.alkalinity && typeof(args.alkalinity) !== 'number') return NaN; // B7
    if (!args.chlorideCM3 && typeof(args.chlorideCM3) !== 'number') return NaN; // B8
    if (!args.versenateCM3 && typeof(args.versenateCM3) !== 'number') return NaN; // B9
    if (args.waterVolumePercent === undefined || typeof(args.waterVolumePercent) !== 'number') return NaN; // B6
    
    var sodiumChloridePresent = args.sodiumChloridePresentFunction({chlorideCM3: args.chlorideCM3, versenateCM3: args.versenateCM3});
    var D17 = args.chlorideCM3 * 10000;
    var D18 = args.versenateCM3 * 4000;

    if (sodiumChloridePresent) {
        console.log("Trying to calc with sodium present");
        var D22 = D18 * 2.769;
        var J2;
        if (args.alkalinity > 0.75) {
            J2 = (1.648*D17)-(3004*((4*args.versenateCM3)-1.5));
        } else {
            J2 = (1.648*D17) - (3004*((4*args.versenateCM3)-(1.997*args.alkalinity)));
        }
        var G22 = J2;
        var D24 = 100*D22/(D22+G22+((args.waterVolumePercent/100)*1000000));
        console.log("Trying to calc checkpoint");
        var I24 = 26.432-(1.0472*D24)+(0.00798191*Math.pow(D24, 2))+(0.000052238*Math.pow(D24, 3));
        var K1 = 100*G22/(G22+D22+((args.waterVolumePercent/100)*1000000));
        var G24 = K1 > I24 ? I24 : K1;
        console.log("Trying to calc checkpoint 2");
        var D25 = 0.99707+(0.0065*G24)+(0.0000439*(Math.pow(G24, 2)))+(0.00792*D24)+(0.0000496*(Math.pow(D24, 2)))+(0.00008334*D24*G24);
        var L6 = D24 * 10000;
        var D28 = L6 * D25;
        return D28 / 1.565;
    } else {

        var B22 = D17 * 1.57;
        var B24 = B22 * 100 / ( B22 + args.waterVolumePercent / 100 * 1000000 );
        var B25 = 1 + ( 0.008117 * B24 ) + ( 0.000040715 * ( Math.pow(B24, 2) ) ) + ( 0.0000001326 * Math.pow(B24, 3) );
        var K6 = B24 * 10000;
        var B28 = K6 * B25;
        return B28 / 1.565;
    }
}

function testFunctions() {

    var testDataSections = getSections({
        drillStringSections:  [
            {
                length: 14300,
                innerPipeDiameter: 3.82,
                outerPipeDiameter: 4.5,
            }
        ],
        intervalSections: [
            {
                length: 14300,
                holeDiameter: 7.875,
            }
        ]
    });
    var testDataOpen = {
        openPipeVelocityFunction: openPipeVelocity,
        pluggedPipeVelocityFunction: pluggedPipeVelocity,
        maximumPipeVelocityFunction: maximumPipeVelocity,
        nValueFunction: nValue,
        kValueFunction: kValue,
        pressureLossFunction: pressureLossLaminar,
        theta300: 80,
        theta600: 140,
        tripSpeed: 270,
        pipeSections: testDataSections,
        isPipeOpen: true,
    }

    var testDataClose = {
        openPipeVelocityFunction: openPipeVelocity,
        pluggedPipeVelocityFunction: pluggedPipeVelocity,
        maximumPipeVelocityFunction: maximumPipeVelocity,
        nValueFunction: nValue,
        kValueFunction: kValue,
        pressureLossFunction: pressureLossLaminar,
        theta300: 80,
        theta600: 140,
        tripSpeed: 270,
        pipeSections: testDataSections,
        isPipeOpen: false,
    }
    var surgeSwabPressureLossMethod1OpenTest = surgeSwabPressureLossMethod1(testDataOpen);
    // console.log("OpenTest: ", surgeSwabPressureLossMethod1OpenTest);
    var surgeSwabPressureLossMethod1PluggedTest = surgeSwabPressureLossMethod1(testDataClose);
    // console.log("PluggedTest: ", surgeSwabPressureLossMethod1PluggedTest);
    var testDataECDSections = getSections({
        drillStringSections: [
            {
                length: 11300,
                outerPipeDiameter: 5
            },
            {
                length: 700,
                outerPipeDiameter: 6.5
            }
        ],
        intervalSections: [
            {
                length: 12000,
                holeDiameter: 8.5
            }
        ]
    });

    var testDataECD = {
        mudWeight: 12.5,
        theta300: 36,
        theta600: 60,
        pipeSections: testDataECDSections,
        nValueFunction: nValue,
        kValueFunction: kValue,
        pressureLossLaminarFunction: pressureLossLaminar,
        pressureLossTurbulentFunction: pressureLossTurbulent,
        annularVelocityFunction: annularVelocity,
        criticalVelocityFunction: criticalVelocity,
        plasticViscosityFunction: calcPlasticViscosity,
        circRate: 400,
        depthTVD: 12000,
    }

    // console.log("");
    // console.log("Bit Data Calcs Testing: ");
    // console.log("");
    var tfaTestData = {jetSizes: [17, 17, 17]};
    var tfaTest = nozzleArea(tfaTestData);
    // console.log("TFA Test: ");
    // console.log("Input: ", tfaTestData);
    // console.log("Results: ", tfaTest);
    var ecdTestResult = ECD(testDataECD);
    // console.log("");
    // console.log("ECD Test: ");
    // console.log("Input:", testDataECD);
    // console.log("Results: ", ecdTestResult);
    var nozzleVelocityTestData = {
        jetSizes: [12, 12, 12],
        circRate: 520,
    };
    var nozzleVelocityTest = nozzleVelocity(nozzleVelocityTestData);
    // console.log("");
    // console.log("Nozzle Velocity Test: ");
    // console.log("Input:", nozzleVelocityTestData);
    // console.log("Results: ", nozzleVelocityTest);

    var impactForceTestData = {
        mudWeight: 12,
        circRate: 520,
        nozzleVelocity: nozzleVelocityTest,
        bitSize: 12.25
    };
    var impactForceTest = jetImpactForce(impactForceTestData);
    // console.log("");
    // console.log("Jet Impact Force: ");
    // console.log("Input:", impactForceTestData);
    // console.log("Results: ", impactForceTest);

    var bpdTestData = {
        mudWeight: 12,
        circRate: 520,
        jetSizes: [12, 12, 12]
    };
    var bpdTest = jetNozzlePressureDrop(bpdTestData);
    // console.log("");
    // console.log("Bit Pressure Drop: ");
    // console.log("Input:", bpdTestData);
    // console.log("Results: ", bpdTest);


    var bhhpTestData = {
        circRate: 520,
        jetNozzlePressureDrop: bpdTest
    };
    var bhhpTest = bitHydraulicHp(bhhpTestData);
    var bhhpsqinTest = bitHydraulicHpPerSquareInch({bitHydraulicHp: bhhpTest, bitSize: 12.25})
    // console.log("");
    // console.log("Bit Hydraulic Horsepower (sq in): ");
    // console.log("Input:", bhhpTestData);
    // console.log("Results: ", bhhpsqinTest);

    var ppdTestData = {
        jetNozzlePressureDrop: bpdTest,
        surfacePressure: 3000,
    };
    var ppdTest = percentPressureDrop(ppdTestData);
    // console.log("");
    // console.log("Percent Pressure Drop: ");
    // console.log("Input:", ppdTestData);
    // console.log("Results: ", ppdTest);

    testDataSections = getSections({
        drillStringSections:  [
            {
                length: 14300,
                innerPipeDiameter: 3.82,
                outerPipeDiameter: 4.5,
            }
        ],
        intervalSections: [
            {
                length: 14300,
                holeDiameter: 7.875,
            }
        ]
    });
    testDataOpen = {
        openPipeVelocityFunction: openPipeVelocity,
        pluggedPipeVelocityFunction: pluggedPipeVelocity,
        maximumPipeVelocityFunction: maximumPipeVelocity,
        nValueFunction: nValue,
        kValueFunction: kValue,
        pressureLossFunction: pressureLossLaminar,
        theta300: 80,
        theta600: 140,
        tripSpeed: 270,
        pipeSections: testDataSections,
        isPipeOpen: true,
    }

    testDataClose = {
        openPipeVelocityFunction: openPipeVelocity,
        pluggedPipeVelocityFunction: pluggedPipeVelocity,
        maximumPipeVelocityFunction: maximumPipeVelocity,
        nValueFunction: nValue,
        kValueFunction: kValue,
        pressureLossFunction: pressureLossLaminar,
        theta300: 80,
        theta600: 140,
        tripSpeed: 270,
        pipeSections: testDataSections,
        isPipeOpen: false,
    }
    var surgeSwabPressureLossMethod1OpenTest = surgeSwabPressureLossMethod1(testDataOpen);
    var surgeSwabPressureLossMethod1PluggedTest = surgeSwabPressureLossMethod1(testDataClose);
    // console.log("");
    // console.log("Surge and Swab Open: ");
    // console.log("Input: ", testDataOpen);
    // console.log("Results: ", surgeSwabPressureLossMethod1OpenTest);
    // console.log("");
    // console.log("Surge and Swab Plugged: ");
    // console.log("Input: ", testDataClose);
    // console.log("Results: ", surgeSwabPressureLossMethod1PluggedTest);


    var myNValue = nValue({theta300:37, theta600: 64});
    var myKValue = kValue({theta300: 37, nValue: myNValue});
    // console.log("");
    // console.log("n: ");
    // console.log("Input: ", {theta300:37, theta600: 64});
    // console.log("Results: ", myNValue);
    // console.log("");
    // console.log("K: ");
    // console.log("Input: ", {theta300:37, theta600: 64});
    // console.log("Results: ", myKValue);

    var testDrillString = [
        { innerPipeDiameter: 4, length: 2, outerPipeDiameter: 6.5 },
        { innerPipeDiameter: 5, length: 10, outerPipeDiameter: 7 }
    ]

    var testInterval = [
        { holeDiameter: 40.42, length: 198 }
    ]

    // console.log("Critical Velocity: ", criticalVelocity({
    //     nValue: myNValue,
    //     kValue: 0.2684,
    //     pipeDiameter: 7,
    //     holeDiameter: 8.5,
    //     mudWeight: 14
    // }))

    var testPump = duplexPumpFlowRateGallonPerStroke({
        linerDiameter: 6,
        rodDiameter: 2,
        strokeLength: 12,
        volumeEfficiency: 1
    })
    testPump = multiplexPumpFlowRateGallonPerStroke({
        linerDiameter: 6,
        linerQty: 3,
        strokeLength: 10,
        volumeEfficiency: 1,
    });
    console.log(testPump);
    testPump = testPump / 42;
    console.log(testPump);
    var drillStringSections = [
        { 
            innerPipeDiameter: 4.75,
            length: 9780,
            outerPipeDiameter: 5 
        },
        {
            innerPipeDiameter: 5.5,
            length: 120,
            outerPipeDiameter: 6
        },
        {
            innerPipeDiameter: 7,
            length: 100,
            outerPipeDiameter: 7.625 
        },
    ];
    var intervalSections = [ { holeDiameter: 13, length: 3000 }, { holeDiameter: 8.75, length: 7000 } ];
    var pipeSections = getSections({drillStringSections: drillStringSections, intervalSections, intervalSections});
    console.log(pipeSections);
    var bottomsUp = bottomUpVolume({pipeSections: pipeSections, cylinderVolumeFunction: cylinderVolumeBarrels});
    var surfaceToBit = surfaceToBitVolume({pipeSections: pipeSections, cylinderVolumeFunction: cylinderVolumeBarrels});
    var surfaceToSurface = surfaceToSurfaceVolume({bottomUpVolume: bottomsUp, surfaceToBitVolume: surfaceToBit});
    console.log(bottomsUp, surfaceToBit, surfaceToSurface);



    var testArgs = {
        mudWeight: 12.1,
        oilVolumePercent: 64,
        waterVolumePercent: 14,
        alkalinity: 2.6,
        chlorideCM3: 3.5,
        versenateCM3: 8,
        oilSpecificGravity: 0.84,
        wtMaterialSpecificGravity: 4.1,
        drillSolidsSpecificGravity: 2.6,
        sodiumChloridePresentFunction: sodiumChloridePresent,
    }

    console.log('=============OBM=============');
    console.log('OBM Solids Tests Args: ', testArgs);
    var testLGPercent = lowGravityPercent(testArgs);
    console.log('Low Gravity Percent: ', testLGPercent);
    var testLGPPB = lowGravityPPB(testArgs);
    console.log('Low Gravity PPB: ', testLGPPB);
    var testHGPercent = highGravityPercent(testArgs);
    console.log('High Gravity Percent: ', testHGPercent);
    var testHGPPB = highGravityPPG(testArgs);
    console.log('High Gravity PPB: ', testHGPPB);
    var testRetort = retortContentSolidsPercent(testArgs);
    console.log('Retort Content: ', testRetort);
    var testASG = averageSpecificGravityOil(testArgs);
    console.log('ASG: ', testASG);
    var testOilRatio = oilRatio(testArgs);
    console.log('Oil Ratio: ', testOilRatio);
    var testWaterRatio = waterRatio(testArgs);
    console.log('Water Ratio: ', testWaterRatio);
    var testAdjustedSolids = adjustedSolidsPercentOil(testArgs);
    console.log('Adjusted Solids: ', testAdjustedSolids);
    var testChlorideMilsPerLiter = chlorideMilsPerLiter(testArgs);
    console.log('Chloride mg/L: ', testChlorideMilsPerLiter);

    console.log('=============WBM=============');

    var wbmTestArgs = {
        mudWeight: 12,
        oilVolumePercent: 0,
        waterVolumePercent: 81,
        chlorideMilsPerLiter: 14554,
        wtMaterialSpecificGravity: 4.2,
        oilSpecificGravity: 0.81,
        lowGravitySolidSpecificGravity: 2.6,
        methyleneBlueTest: 25.0,
        cationExchangeCapacity: 7.0,
        getSaltTypeCoefficientFunction: getSaltTypeCoefficient,
        saltType: 'KCL',

    }
    var testSaltPercentVolume = saltPercentByVolume(wbmTestArgs);
    wbmTestArgs.saltPercentByVolume = testSaltPercentVolume;
    console.log('Salt Percent Volume: ', testSaltPercentVolume);
    var adjustedChlorideWater = adjustedChloride(wbmTestArgs);
    console.log('AdjustedChlorideWater: ', adjustedChlorideWater);
    wbmTestArgs.adjustedChloride = adjustedChlorideWater;
    var testSaltPercentWW = saltPercentWW(wbmTestArgs);
    console.log('Salt Percent WW: ', testSaltPercentWW);
    wbmTestArgs.saltPercentWW = testSaltPercentWW;
    var testBrineSpecificGravity = brineSpecificGravity(wbmTestArgs);
    wbmTestArgs.brineSpecificGravity = testBrineSpecificGravity;
    console.log('Brine Specific Gravity: ', testBrineSpecificGravity);
    var testAdjustSolidsPercent = adjustedSolidsPercentWater(wbmTestArgs);
    wbmTestArgs.adjSolidsPercent = testAdjustSolidsPercent;
    console.log('Adjusted Salt Percent: ', testAdjustSolidsPercent);
    var testLowGravityPercent = lowGravityPercentWater(wbmTestArgs);
    wbmTestArgs.lowGravityPercent = testLowGravityPercent;
    console.log('Low Gravity Percent: ', testLowGravityPercent);
    var testHighGravityPercent = highGravityPercentWater(wbmTestArgs);
    console.log('High Gravity Percent: ', testHighGravityPercent);
    var lowGravityPPBTestArgs = {
        gravityPercent: testLowGravityPercent,
        gravitySolidSpecificGravity: wbmTestArgs.lowGravitySolidSpecificGravity,
    }
    var lowGravityPPBTestResult = gravityPPB(lowGravityPPBTestArgs);
    console.log('Low Gravity PPB: ', lowGravityPPBTestResult);
    var highGravityPPBTestArgs = {
        gravityPercent: testHighGravityPercent,
        gravitySolidSpecificGravity: wbmTestArgs.wtMaterialSpecificGravity,
    }
    var highGravityPPBTestResult = gravityPPB(highGravityPPBTestArgs);
    console.log('High Gravity PPB: ', highGravityPPBTestResult);
    wbmTestArgs.lowGravityPPB = lowGravityPPBTestResult;
    wbmTestArgs.highGravityPPB = highGravityPPBTestResult;
    var testBentonitePPB = bentonitePPB(wbmTestArgs);
    console.log('Bentonite PPB: ', testBentonitePPB);
    wbmTestArgs.bentonitePPB = testBentonitePPB;
    var testBentontePercent = bentonitePercent(wbmTestArgs);
    console.log('Bentonite Percent: ', testBentontePercent);
    wbmTestArgs.bentonitePercent = testBentontePercent;
    var testDrillSolidPercent = drillSolidsPercent(wbmTestArgs);
    console.log('Drill Solids Percent: ', testDrillSolidPercent);
    var testDrillSolidPPB = drillSolidsPPB(wbmTestArgs);
    console.log('Drill Solids PPB: ', testDrillSolidPPB);
    var testASGWater = averageSpecificGravityWater(wbmTestArgs);
    console.log('ASG Water: ', testASGWater);
}

// testFunctions();




// WEBPACK FOOTER //
// ./src/JavascriptCalculation/JavascriptCalculation.js